import { getToken } from './token';

window.axios = require('axios');
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.baseURL = process.env.VUE_APP_BASE_API + '/api';
// axios.defaults.headers.common['Authorization'] = process.env.VUE_APP_TOKEN;
axios.defaults.headers.common['Authorization'] = process.env.VUE_APP_DEFAULT_TOKEN ? process.env.VUE_APP_DEFAULT_TOKEN : getToken();

import { apiGet, apiPost, apiPut, apiDelete } from './api';
window.apiGet = apiGet;
window.apiPost = apiPost;
window.apiPut = apiPut;
window.apiDelete = apiDelete;

import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'
loadProgressBar();